import { useEffect, useState } from "react";
import debug from "debug";
import { DEVICE_MARKET_URL_KEY, GET_LOCATION_BY_IP_URL, MARKET_URL_KEY } from "../constants";
import { useSearchParamsConfig } from "./useSearchParamsConfig";
const log = debug("desjti:country-selector:useGeoAndRedirect");
/**
 * Hook for loading address, enabled countries, and performing auto-redirect.
 */
export const useGeoAndRedirect = (countriesApi, editor) => {
    const [address, setAddress] = useState({
        ipAddress: "",
        countryRegion: { isoCode: "" },
    });
    const [enabledData, setEnabledData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { search: queryString, isSearchParamLoaded, bypass, isDeviceSource, noGeo } = useSearchParamsConfig();
    useEffect(() => {
        if (editor) {
            setLoading(false);
            return;
        }
        const fetchData = async () => {
            if (!isSearchParamLoaded) {
                return;
            }
            try {
                const [addrRes, countriesRes] = await Promise.all([
                    fetch(GET_LOCATION_BY_IP_URL).then((r) => r.json()),
                    fetch(countriesApi).then((r) => r.json()),
                ]);
                let addr = addrRes;
                if (bypass) {
                    addr = {
                        ...addr,
                        countryRegion: { isoCode: bypass },
                    };
                }
                setAddress(addr);
                const dataArray = countriesRes[0]?.data || [];
                setEnabledData(dataArray);
                if (!noGeo && addr.countryRegion.isoCode) {
                    const key = isDeviceSource ? DEVICE_MARKET_URL_KEY : MARKET_URL_KEY;
                    const foundItem = dataArray.find((e) => e.code === addr.countryRegion.isoCode);
                    if (foundItem?.data[key]) {
                        window.location.href = `${foundItem.data[key]}${queryString}`;
                        return;
                    }
                }
            }
            catch (e) {
                log("Error in useGeoAndRedirect", e);
            }
            finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [countriesApi, editor, bypass, isDeviceSource, noGeo, isSearchParamLoaded, queryString]);
    return { address, loading, enabledData, noGeo };
};
//# sourceMappingURL=useGeoAndRedirect.js.map